import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { CompanyModel } from './companies.model';
import { AppService } from '../../app.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ServiceProviderSettingComponent } from '../service-provider-setting.component';
import { ServiceProviderSettingService } from '../service-provider-setting.service';

@Component({
    selector: 'companies-component',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.scss'],
    providers: [ServiceProviderSettingService, BaseService]
})

export class CompaniesComponent extends ServiceProviderSettingComponent implements OnInit, AfterViewInit {
    @ViewChild('dialogLogo', { static: false }) dialogLogo: DialogComponent;
    @ViewChild('modalDeleteCompanies', {static: false}) modalDeleteCompanies: ModalDirective;

    readonly tableColumns = [
        ['id', 'ID', 'col-xs-1' , 'id', 'default'],
        ['name', 'Name', 'col-xs-11', 'text', 'default'],
    ];
    items: any;
    totalItems = 0;

    constructor(public authService: AuthService,
                public baseService: BaseService,
                public appService: AppService,
                public router: Router,
                public route: ActivatedRoute,
                public translate: TranslateService,
                public fb: FormBuilder,
                public serviceProviderService: ServiceProviderSettingService) {
        super(authService, router, baseService, appService, fb, serviceProviderService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.searchInfo = new CompanyModel();
        this.url = 'service-provider-setting/companies';
        this.tabName = 'Company';
        this.componentUrl = 'companies';
    }

    ngAfterViewInit(): void {
        this.initAction();
        super.deleteModal = this.modalDeleteCompanies;
    }

    initFormDataToModal(form, response){
        if (this.form != null) {
            this.form.reset(form);
        } else {
            this.form = this.fb.group(form);
            this.form.controls['name'].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
        }
    }
}
